import { FlagProgressType } from "../conversation/messageFlagging/types";
export const DEFAULT_INFERENCE_MODEL = "default";
export const DEFAULT_INFERENCE_SETTINGS = {
    temperature: 0.7,
    maxNewTokens: 180,
    topP: 0.7,
    topK: 90,
};
export const INFERENCE_MODEL_KEY = "inference_model";
export const INFERENCE_MAX_NEW_TOKENS_KEY = "inference_max_new_tokens";
export const INFERENCE_TEMPERATURE_KEY = "inference_temperature";
export const INFERENCE_TOPP_KEY = "inference_top-p";
export const INFERENCE_TOPK_KEY = "inference_top-k";
export const BLOCK_USER_CONFIRMATION_MESSAGE = "Are you certain you want to block all chatbots from creator @";
export const CONFIRMATION_MESSAGE_UNBLOCK_CREATOR = "Are you sure to unblock the creator @";
export const CONVIMAGE_MODELSTYLE_KEY = "convimage_modelstyle";
export const CONVIMAGE_NSFWMODE = "convimage_nsfwmode";
export const CONVIMAGE_LEGACYMODE = "convimage_legacymode";
export const CONVIMAGE_LORASCALE = "convimage_lorascale";
export const CONVIMAGE_USER_PROMPT_SUFFIX = "convimage_user_prompt_suffix";
export const CONVIMAGE_USER_NEGATIVE_PROMPT = "convimage_user_negative_prompt";
export const CONVIMAGE_INCLUDE_PERSONA = "convimage_include_persona";
// Image model style constants
export const IMAGE_MODEL_STYLE = {
    SEMI_REALISTIC: "semi-realistic",
    ANIME: "anime",
    FLUX: "flux",
    FLUX_MALE: "flux_male",
    QWEN: "qwen",
    QWEN_MALE: "qwen_male",
};
export const CAPPED_NOTICE_MIN_MESSAGE_LIMIT = 10;
export const COPIED_MESSAGE = "Copied to clipboard";
export const CHAT_MESSAGE_ACTIONS = {
    COPY: "copy",
    EDIT: "edit",
    REMOVE_IMAGE: "remove_image",
    RATE_VOICE: "rate_voice",
    REPORT: "report",
    DELETE: "delete",
};
export const REPORT_HEADERS = {
    [FlagProgressType.SELECT_OPTION]: {
        description: "chat:modal.reportMessage.selectOption.description",
        subDescription: "chat:modal.reportMessage.selectOption.subDescription",
    },
    [FlagProgressType.ADD_COMMENT]: {
        description: "chat:modal.reportMessage.addComment.description",
        subDescription: "chat:modal.reportMessage.addComment.subDescription",
    },
    [FlagProgressType.DONE]: {
        description: "chat:modal.reportMessage.confirmation.description",
        subDescription: "",
    },
    [FlagProgressType.ERROR]: {
        description: "error:title.somethingWentWrong",
        subDescription: "error:subtitle.pleaseTryAgain",
    },
};
export const PC_DISCLAIMER = "SpicyChat is powered by AI for creative storytelling and roleplay. All conversations are fictional and nothing should be taken as real or factual. Enjoy responsibly!";
export const MOBILE_DISCLAIMER = "This is an AI chatbot. All conversations are fictional and for entertainment purposes only!";
export const MAX_IMAGE_SIZE = 20; // 20 MB
export const IMAGE_INPUT_ID = "image-picker";
export const ACCEPTED_FILE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic"];
